<template>
  <div class="rating w-full border rounded overflow-hidden">
    <div class="balance p-1 text-center" :style="'width:' + percent + '%;'" :class="{ 'showbalance': showbalance }">
      {{ value | ceil }}
      <span v-if="this.mode !== 'school'">%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rating',
  props: ['value', 'mode'],

  data () {
    return {
      percent: 66,
      showbalance: false
    }
  },

  created () {
    this.percent = this.value

    if (this.mode === 'school') {
      this.percent = (6 - this.value) * 20
    }

    setTimeout(() => { this.showbalance = true }, 500)
  },

  filters: {
    ceil (value) {
      return Math.ceil(Number(value))
    }
  }
}
</script>

<style lang="scss" scoped>
  .balance {
    @apply bg-green-heinz;
    @apply relative;
    @apply whitespace-no-wrap;
    @apply overflow-visible;

    &:after {
      @apply absolute;
      @apply pin-t;
      @apply pin-r;
      @apply w-full;
      @apply h-full;
      @apply bg-white;

      content: '';
      transition: width 1.5s ease-in-out;
    }
  }

  .balance.showbalance {
    &:after {
      width: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rating.vue